export class CustomerFilter {
    
    constructor(name?: string, customerGroupId?: string) {
        this.name = name;
        this.customerGroupId = customerGroupId;
    }

    name?: string;
    customerGroupId?: string
}